<template>
  <alert-tooltip
    ref="alertTooltip"
    :heading="heading"
    :message="message"
    @dismiss="dismissTip"
    :placement="placement"
    :target="target"
  />
</template>

<script>
import AlertTooltip from '@/components/tooltip/AlertTooltip.vue'
import { storageFlags } from '@/utils/storageUtils'

/**
 * This component is used to show a tooltip on a control (prop - target). Tooltip once dismissed does not appear again
 */
export default {
  name: 'FeatureTooltip',
  props: {
    message: String,
    heading: String,
    /*
    key in localstorage which contain info if user dismissed this top
     */
    storageKey: String,
    /*
    id of the element over which the tooltip should come
     */
    target: String,
    placement: {
      type: String,
      default: 'bottomleft'
    }
  },
  components: {
    AlertTooltip
  },
  data() {
    return {}
  },
  methods: {
    dismissTip() {
      storageFlags.set(this.storageKey)
    }
  },
  mounted() {
    setTimeout(() => {
      const show = !storageFlags.get(this.storageKey)
      if (show) {
        this.$refs.alertTooltip.show()
      }
    }, 0)
  }
}
</script>

<style lang="scss" scoped></style>
